import { createRouter, createWebHistory } from 'vue-router'
import LandingPage from '../views/LandingPage.vue'; // --- NEW: Import Landing Page
import ClientDashboard from '../views/ClientDashboard.vue'
import LoginView from '../views/LoginView.vue'
import GuestReleaseForm from '../views/GuestReleaseForm.vue'
import SubmissionDetailView from '../views/SubmissionDetailView.vue'
import AllSubmissionsView from '../views/AllSubmissionsView.vue'
import SuperAdminView from '../views/SuperAdminView.vue';
import EditClientView from '../views/EditClientView.vue';
import ProfileView from '../views/ProfileView.vue';
import PodcastGuestGuide from '../views/PodcastGuestGuide.vue';
import PublicPodcastPage from '../views/PublicPodcastPage.vue';
import EpisodeDetailView from '../views/EpisodeDetailView.vue';
import { auth } from '@/firebase';
import { onAuthStateChanged } from 'firebase/auth';

const getCurrentUser = () => {
  return new Promise((resolve) => {
    const removeListener = onAuthStateChanged(auth, (user) => {
      removeListener();
      resolve(user);
    });
  });
};

const routes = [
  // --- START: Route Updates ---
  { path: '/', name: 'landing', component: LandingPage },
  { path: '/dashboard', name: 'client-dashboard', component: ClientDashboard, meta: { requiresAuth: true } },
  // --- END: Route Updates ---
  { path: '/submission/:id', name: 'submission-detail', component: SubmissionDetailView, meta: { requiresAuth: true } },
  { path: '/submissions', name: 'all-submissions', component: AllSubmissionsView, meta: { requiresAuth: true } },
  { path: '/super-admin', name: 'super-admin', component: SuperAdminView, meta: { requiresAuth: true, requiresSuperAdmin: true } },
  { path: '/client/:id/edit', name: 'edit-client', component: EditClientView, meta: { requiresAuth: true, requiresSuperAdmin: true } },
  { path: '/profile', name: 'profile', component: ProfileView, meta: { requiresAuth: true } },
  { path: '/login', name: 'login', component: LoginView, meta: { fullScreen: true } },
  { path: '/guest-release-form/:id', name: 'guest-release-form', component: GuestReleaseForm },
  { path: '/guest-guide/:id', name: 'guest-guide', component: PodcastGuestGuide },
  {
    path: '/shows/:slug',
    name: 'public-podcast-page',
    component: PublicPodcastPage,
  },
  {
    path: '/shows/:slug/:episodeId',
    name: 'episode-detail-page',
    component: EpisodeDetailView,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresSuperAdmin = to.matched.some(record => record.meta.requiresSuperAdmin);
  const currentUser = await getCurrentUser();

  if (requiresAuth && !currentUser) {
    next('/login');
  } else if (requiresSuperAdmin) {
    if (currentUser) {
      const idTokenResult = await currentUser.getIdTokenResult(true);
      if (idTokenResult.claims.role === 'super-admin') {
        next();
      } else {
        // --- AMENDED: Redirect non-super-admins to their dashboard, not the landing page
        next('/dashboard');
      }
    } else {
      next('/login');
    }
  } else {
    next();
  }
});

export default router;